<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard addPage">
        <div class="p-grid">
            <div class="p-col-12 mainFormPadding">
                <div class="card ">
                    <p-toast key="toastmsg" position="top-right"></p-toast>
                    <form [formGroup]="pushNotificationForm" *ngIf="this.pushNotificationForm">
                        <div class="p-fluid p-formgrid p-grid m-0">
                            <div class="p-field p-col-12 div-border p-p-0">
                                <h3 class="head-page-title">
                                    {{pagetitle}}
                                </h3>
                            </div>
                        </div>

                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 p-fluid p-formgrid p-grid mainFormGap">
                                <div class="p-field p-col-4">
                                    <label for="name">Name <span class="mandatory-fields">*</span></label>
                                    <input formControlName="name" type="text" pInputText class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.name.errors }">
                                    <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                                        <div *ngIf="f.name?.errors?.required">Name is required</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4">
                                    <label for="slug">Slug <span class="mandatory-fields">*</span></label>
                                    <input formControlName="slug" type="text" pInputText [readonly]="disabled"
                                        class="form-control" [ngClass]="{ 'is-invalid': submitted && f.slug.errors }">
                                    <div *ngIf="submitted && f.slug.errors" class="invalid-feedback">
                                        <div *ngIf="f.slug.errors.required">Slug is required</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4 addFormDropDown">
                                    <label for="type">Type <span class="mandatory-fields">*</span></label>
                                    <p-dropdown inputId="type" [options]="pushNotificationTypes" formControlName="type"
                                        placeholder="Select Type" optionLabel="label"
                                        [ngClass]="{ 'is-invalid': submitted && f.type.errors }"></p-dropdown>
                                    <div *ngIf="submitted && f.type.errors" class="invalid-feedback">
                                        <div *ngIf="f.type.errors.required">Type is required</div>
                                    </div>
                                </div>

                                <div class="p-field p-col-6 addFormDropDown">
                                    <label for="module">Module <span class="mandatory-fields">*</span></label>
                                    <p-dropdown inputId="module" [options]="pushNotificationModules"
                                        formControlName="module" placeholder="Select Module" optionLabel="name"
                                        [ngClass]="{ 'is-invalid': submitted && f.module.errors }"></p-dropdown>
                                    <div *ngIf="submitted && f.module.errors" class="invalid-feedback">
                                        <div *ngIf="f.module.errors.required">Module is required</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-6 addFormDropDown">
                                    <label for="appType">App Type <span class="mandatory-fields">*</span></label>
                                    <p-dropdown inputId="appType" [options]="pushNotificationAppTypes"
                                        formControlName="appType" placeholder="Select App Type" optionLabel="label"
                                        [ngClass]="{ 'is-invalid': submitted && f.appType.errors }"></p-dropdown>
                                    <div *ngIf="submitted && f.appType.errors" class="invalid-feedback">
                                        <div *ngIf="f.appType.errors.required">App Type is required</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-6">
                                    <label for="notificationHeaderName">Header Name <span
                                            class="mandatory-fields">*</span></label>
                                    <input formControlName="notificationHeaderName" type="text" pInputText
                                        class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.notificationHeaderName.errors }">
                                    <div *ngIf="submitted && f.notificationHeaderName.errors" class="invalid-feedback">
                                        <div *ngIf="f.notificationHeaderName.errors.required">Header Name is required
                                        </div>
                                    </div>
                                </div>
                                <div class="p-field p-col-6 notificationIconform">
                                    <label for="notificationIcon">Icon <span class="mandatory-fields">*</span></label>
                                    <div class="file-upload-wrapper">
                                        <input type="file" #fileInput (change)="onFileSelect($event)" accept="image/*"
                                            style="display: none;" id="notificationIconFile">
                                        <button type="button" pButton icon="pi pi-upload" label="Upload Icon"
                                            class="p-button-outlined" (click)="fileInput.click()"
                                            style="width: 100%; margin-bottom: 10px;"></button>
                                        <div *ngIf="notificationIconPreview" class="image-preview-container"
                                            style="position: relative; display: inline-block; margin-top: 10px;">
                                            <img [src]="notificationIconPreview" alt="Icon Preview"
                                                style="max-width: 95px; max-height: 95px; border: 1px solid #ddd; border-radius: 4px; padding: 5px;">
                                            <button type="button" pButton icon="pi pi-times"
                                                class="p-button-rounded p-button-danger p-button-sm"
                                                (click)="removeIcon()"
                                                style="position: absolute; top: -10px; right: -10px;"></button>
                                        </div>
                                    </div>
                                    <div *ngIf="submitted && f.notificationIcon.errors" class="invalid-feedback"
                                        style="display: block;">
                                        <div *ngIf="f.notificationIcon.errors.required">Icon is required</div>
                                    </div>
                                    <div class="instruction mt-3 mb-3">
                                        <p>Instructions: </p>
                                        <ul>
                                            <li>1) The cropped Icon will be 100 x 100 px, with a maximum size of 1 MB.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="p-field p-col-12">
                                    <label for="description">Description <span class="mandatory-fields">*</span></label>
                                    <textarea inputId="textarea" formControlName="description" rows="5" cols="30"
                                        class="form-control" pInputTextarea
                                        [ngClass]="{ 'is-invalid': submitted && f.description.errors }"></textarea>
                                    <div *ngIf="submitted && f.description.errors" class="invalid-feedback">
                                        <div *ngIf="f.description.errors.required">Type is required</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4 statusdivMain">
                                    <label for="status">Status </label>
                                    <p-inputSwitch class="checkbox-mt-10" formControlName="status"
                                        [ngClass]="{ 'is-invalid': submitted && f.status.errors }"></p-inputSwitch>
                                    <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                                        <div *ngIf="f.status.errors.required">App Type is required</div>
                                    </div>
                                </div>

                                <!-- <div class="p-field p-col-4 statusdivMain">
                            <label for="status">Status </label>
                            <p-inputSwitch class="checkbox-mt-10" formControlName="status"
                                [ngClass]="{ 'is-invalid': submitted && f.status.errors }"></p-inputSwitch>
                            <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                                <div *ngIf="f.status.errors.required">App Type is required</div>
                            </div>
                        </div> -->
                                <div class="p-field p-col-12">
                                    <div class="lineborderHR">
                                        <hr>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="button-set p-col-12 d-flex p-fluid p-jc-md-end bottom-footer">
                            <div class="p-formgrid p-grid">
                                <p-toast></p-toast>
                                <button type="text" (click)="onSubmit()" pButton icon="pi pi-check" label="Save"
                                    class="p-button-success save-btn p-mr-3" style="width: auto"></button>
                                <button type="text" (click)="backLink()" pButton icon="pi pi-times" label="Cancel"
                                    class="p-button-danger cancel-btn" style="width: auto"></button>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="button-set back">
                    <div class="p-fluid p-formgrid">
                        <p-toast></p-toast>
                    </div>
                </div>
            </div>
            <p-confirmDialog [style]="{width:'450px'}"></p-confirmDialog>
        </div>
    </div>
    <p-dialog
        [(visible)]="cropDialog"
        [closable]="true"
        (onHide)="onDialogHide()"
        [modal]="true"
        [appendTo]="'body'"
        [style]="{width: '720px'}"
        [breakpoints]="{'768px': 'calc(100vw - 24px)'}"
        styleClass="custom-crop-dialog">
        <ng-template pTemplate="header">
            <div class="crop-header-wrapper">
                <div class="crop-header-icon-box">
                    <i class="pi pi-image header-icon"></i>
                </div>
                <div class="crop-header-text">
                    <h5 class="crop-dialog-title">{{cropDialogTitle}}</h5>
                    <p class="crop-dialog-subtitle">{{cropDialogSubtitle}}</p>
                </div>
            </div>
        </ng-template>

        <div class="crop-dialog-content-wrapper">
            <div class="crop-toolbar-bar mb-3">
                <div class="toolbar-hint">
                    <i class="pi pi-sliders-h mr-2 hint-icon"></i>
                    <span>Zoom & Scale</span>
                </div>
                   <div class="zoom-actions">
                    <button type="button" pButton icon="pi pi-search-plus" label="Zoom In" class="crop-btn zoom-btn"
                        (click)="zoomIn()"></button>
                    <button type="button" pButton icon="pi pi-search-minus" label="Zoom Out" class="crop-btn zoom-btn"
                        (click)="zoomOut()"></button>
                    <button type="button" pButton icon="pi pi-refresh" label="Reset" class="crop-btn reset-btn"
                        (click)="resetZoom()"></button>
                </div>
            </div>

            <div class="cropper-frame mb-3">
                <image-cropper
                    [imageChangedEvent]="imageChangedEvent"
                    [maintainAspectRatio]="true"
                    [aspectRatio]="1"
                    [resizeToWidth]="100"
                    [resizeToHeight]="100"
                    [onlyScaleDown]="false"
                    [imageQuality]="92"
                    [backgroundColor]="'#ffffff'"
                    [transform]="transform"
                    format="jpeg"
                    (imageCropped)="imageCropped($event)"
                    (loadImageFailed)="onCropImageLoadFailed()">
                </image-cropper>
            </div>

            <div class="crop-error-msg mb-3" *ngIf="croppedImageError">
                <i class="pi pi-exclamation-triangle mr-2"></i>
                <span>{{croppedImageError}}</span>
            </div>

            <div class="cropped-preview-box" *ngIf="croppedImage">
                <div class="preview-header">
                    <div class="preview-title">
                        <i class="pi pi-eye mr-2 text-primary"></i>
                        <span>Live Cropped Preview</span>
                    </div>
                    <span class="preview-ratio-badge">{{cropPreviewLabel}}</span>
                </div>
                <div class="preview-img-container">
                    <img [src]="croppedImage" alt="Cropped Notification Icon Preview" class="preview-img" />
                </div>
            </div>
        </div>

        <ng-template pTemplate="footer">
            <div class="dialog-footer-actions">
                <button type="button" pButton label="Cancel" icon="pi pi-times"
                    class="cancel-action-btn" (click)="onCropCancel()"></button>
                <button type="button" pButton label="Use Image" icon="pi pi-check"
                    class="use-image-btn" (click)="applyCrop()"
                    [disabled]="isApplyingCrop || !croppedImage || !!croppedImageError"></button>
            </div>
        </ng-template>
    </p-dialog>
</div>